export default {
  dropdownJobTitles: state => {
    return state.jobTitlesList
  },
  singleDropdownJobTitles: state => {
    return state.jobTitlesList.map(jobTitle => ({
      text: jobTitle.name,
      value: jobTitle.id.toString()
    }))
  },
  allJobTitles: state => {
    return state.jobTitlesList
  }
}
